import EpisodeSuggestions, {
  EpisodeSuggestionsProps,
} from './EpisodeSuggestions';

export default EpisodeSuggestions;
export type { EpisodeSuggestionsProps };
